export const startDate = new Date('5/5/2023');
